import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import { useSelector } from 'react-redux';
import SkeletonAdmin from '../preloadSkeleton';
import UserCard from './userCard';
import { Button, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';
import ModalEditUser from './modalEditUser';

const MainUser = styled.main`
  background-color: ${palette.white};
  border-radius: 10px;
  box-shadow: ${palette.lightBS};
  .box_c_u {
    overflow: auto;
    height: 64vh;
    padding: 2%;

    &::-webkit-scrollbar {
      width: 0em;
      height: 0em;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0rem;
    }
  }
  .box_container_user_card {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
  }

  .box_head_user {
    align-self: center;
    display: grid;
    grid-gap: 0px;
    padding: 10px;
    grid-template-columns: 2fr 1fr;
    width: 100%;
    align-items: end;
    img {
      width: 50%;
    }

    .button_add_user {
      padding: 2%;
      justify-self: center;
      align-self: center;

      .button_add_user_int {
        background-color: #5373fc;
        padding: 7px 17px;
        span {
          color: #ffffff;
          font-size: 14px;
          font-family: ${palette.nereg};
        }
      }
    }
  }
`;

const ContainerUser = () => {
  const { t } = useTranslation(['admin']);
  const { users } = useSelector((state) => state.company);
  const [openPreload, setOpenPreload] = React.useState(true);
  const [state, setState] = React.useState({
    usernameFilter: '',
    FilterDep: '',
    showModal: false,
    showModalEdit: false,
    Users: [],
  });

  React.useEffect(() => {
    setTimeout(() => setOpenPreload(false), 2000);
    setState((prev) => ({ ...prev, Users: users }));
  }, [users]);

  const ToggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
    }));
    if (!state.showModal) {
      setState((prev) => ({
        ...prev,
        userEdit: {},
      }));
    }
  };

  const EditModal = (value) => {
    ToggleModal();
    setState((prevState) => ({
      ...prevState,
      userEdit: value,
    }));
  };
  const Search = ({ target }) => {
    const { name, value } = target;
    const array = [];
    if (users)
      users.map((user) => {
        if (
          new RegExp(`${value.toUpperCase()}.*`).test(user.names.toUpperCase()) ||
          new RegExp(`${value.toUpperCase()}.*`).test(user.lastNames.toUpperCase())
        ) {
          array.push(user);
        }
        return null;
      });
    setState((prevState) => ({ ...prevState, [name]: value, Users: array }));
  };

  return (
    <MainUser>
      {state.showModal ? <ModalEditUser user={state.userEdit} toggleModal={ToggleModal} /> : null}
      <div className="box_head_user">
        <TextField
          id="input-with-icon-textfield"
          type="text"
          name="usernameFilter"
          placeholder={t('SearchBy')}
          onChange={Search}
          value={state.usernameFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <SearchIcon onClick={Search} style={{ cursor: 'pointer' }} />
              </InputAdornment>
            ),
          }}
        />
        <div className="button_add_user">
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            className="button_add_user_int"
            onClick={ToggleModal}>
            {t('AddUser')}
          </Button>
        </div>
      </div>
      <div className="box_c_u">
        <div className="box_container_user_card">
          {openPreload ? (
            <>
              <SkeletonAdmin height="9vh" width="100%" styleProps={{ borderRadius: '8px' }} />
              <SkeletonAdmin height="9vh" width="100%" styleProps={{ borderRadius: '8px' }} />
              <SkeletonAdmin height="9vh" width="100%" styleProps={{ borderRadius: '8px' }} />
              <SkeletonAdmin height="9vh" width="100%" styleProps={{ borderRadius: '8px' }} />
            </>
          ) : (
            <>
              {state?.Users?.map((user) => (
                <UserCard user={user} editUser={EditModal} key={user?.id} />
              ))}
            </>
          )}
        </div>
      </div>
    </MainUser>
  );
};

export default ContainerUser;
